// 科目/学段/状态的展示映射
export const SUBJECTS = [
  { code: 'math', name: '数学', icon: '📐' },
  { code: 'physics', name: '物理', icon: '💡' },
  { code: 'chemistry', name: '化学', icon: '⚗️' },
] as const;

export const LEVELS = [
  { code: 'junior', name: '初中' },
  { code: 'senior', name: '高中' },
  { code: 'college', name: '大学' },
] as const;

export const subjectName = (c: string) => SUBJECTS.find((s) => s.code === c)?.name || c;
export const levelName = (c: string) => LEVELS.find((l) => l.code === c)?.name || c;

export const PROBLEM_STATUS: Record<string, { label: string; cls: string }> = {
  pending: { label: '未解', cls: 'bg-gray-100 text-gray-600' },
  solving: { label: '解答中…', cls: 'bg-blue-100 text-blue-700' },
  solved: { label: '已解', cls: 'bg-emerald-100 text-emerald-700' },
  error: { label: '失败', cls: 'bg-red-100 text-red-700' },
};

export const VERDICTS: Record<string, { label: string; cls: string; icon: string }> = {
  correct: { label: '对', cls: 'bg-emerald-50 border-emerald-300 text-emerald-800', icon: '✅' },
  partial: { label: '部分对', cls: 'bg-amber-50 border-amber-300 text-amber-800', icon: '⚠️' },
  wrong: { label: '错', cls: 'bg-red-50 border-red-300 text-red-800', icon: '❌' },
};

export const SEVERITIES: Record<string, { icon: string; cls: string }> = {
  good: { icon: '✓', cls: 'text-emerald-600' },
  warning: { icon: '!', cls: 'text-amber-600' },
  error: { icon: '✗', cls: 'text-red-600' },
};
